<form nestableForm data-testid="xi-choose-company-form">

    <div class="loadingio-spinner-rolling-vo35qopy26" style="display: none;">
        <div class="ldio-ty68crv3j7">
            <div></div>
        </div>
    </div>

    <div [height]="15"></div>
    <div *ngIf="isShowClose" class="close-cnt cnt-row">
        <div class="filler"></div><close-btn (click)="onClose()"></close-btn><div [width]="10"></div>
    </div>
    <div class="cnt-column-centered">

        <div class="h1Font b1Color text-center" i18n>{{ 'CHOOSE_A_XERO_COMPANY' | translate }}</div>
        <div [height]="30"></div>
        <div class="p1Font b1Color titleTxt" i18n>
            {{ 'CHOOSE_WHICH_COMPANY_YOU' | translate }}<br />
            {{ 'COMPANY_FROM_YOUR_XERO' | translate }}
        </div>
        <div [height]="40"></div>

        <div class="pane">

            <div class="cnt-row-centered">
                <span class="h2Font b1Color" i18n>{{ 'YOUR_CONNECTED_COMPANIES' | translate }}</span><div class="filler"></div>  
                <div class="company h5Font g5Color" style="cursor:pointer" (click)="connectNew()" data-testid="connectNewCompany">{{ 'CONNECT_A_NEW_COMPANY' | translate }}</div>
            </div>
            <div [height]="30"></div>
            <div class="line-thin g4Background"></div>
            <div [height]="20"></div>
            <div class="cnt-row-centered item"
                 *ngFor="let company of companies"
                 [ngClass]="{'selected': (IsDayLimitReached(company) === false) && company.selected,
                            'limit-reached': IsDayLimitReached(company) === true && company.selected}"
                 (click)="selectClick(company)"
                 data-testid="xeroCompany">

                <ng-template [ngIf]="IsDayLimitReached(company) === true">
                    <div [ngClass]="{'name-limit': company.selected, 'name-txt': !company.selected}" class="name-limit">{{company.name}}</div><div class="filler"></div><div [ngClass]="{'selected-limit-reached': company.selected, 'non-selected-limit-reached': !company.selected}" i18n>{{ 'DAILY_LIMIT_REACHED' | translate }}</div>
                    <div class="cnt-row-centered">
                        <div class="warning-icon"></div>
                    </div>
                </ng-template>

                <ng-template [ngIf]="IsDayLimitReached(company) === false">
                    <div class="name-txt" attr.data-testid="xeroCompany-{{company.name}}">{{company.name}}</div>
                    <div class="filler"></div>
                    <div class="select-txt" i18n>{{ 'SELECTED' | translate }}</div>
                    <div class="inactive-pointer cnt-row-centered">
                        <div class="back-arrow-dark"></div>
                        <span [width]="5"></span>
                        <span class="oneline h5Font b1Color" i18n>{{ 'SELECT_COMPANY' | translate }}</span>
                    </div>
                </ng-template>

            </div>

        </div>

    </div>

</form>
